import {
  AdminLevelFormI,
  GroupManagementFormI,
  paramsI
} from '../../../types/interface';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'redux/rootReducer';
import { GROUP_MANAGEMENT_URLS } from './GroupManagementUrls';
import instance from 'utils/apiCalls';
import { GroupManagementSlice } from './GroupManagementSlice';

const { actions } = GroupManagementSlice;

export const createGroupManagement = (data: any) => async () => {
  const response = await instance.post(
    GROUP_MANAGEMENT_URLS.CREATE_GROUP_ADMIN_LAVEL,
    data
  );
  return response;
};

export const getAllGroupManegement =
  (params?: paramsI) =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(
      GROUP_MANAGEMENT_URLS.GET_GROUP_ADMIN_LEVELS_MAPPINGS,
      { params: params }
    );

    if (response?.data?.meta?.page) {
      dispatch(
        actions.setGroupManagementMeta({
          meta: {
            total: response.data.meta.total,
            limit: response.data.meta.limit
          }
        })
      );
    }
    return response;
  };

export const getSingleGroupManagement = (id: any, params?: any) => async () => {
  const response = await instance.get(
    GROUP_MANAGEMENT_URLS.GET_SINGLE_GROUP_ADMIN_LAVEL.replace(
      ':id',
      id?.toString()
    ),
    { params }
  );
  return response;
};

export const updateGroupManagement = (id: any, data: any) => async () => {
  const response = await instance.put(
    GROUP_MANAGEMENT_URLS.UPDATE_GROUP_ADMIN_LAVEL.replace(
      ':id',
      id?.toString()
    ),
    data
  );
  return response;
};

export const deleteGroupManagement = (id: any) => async () => {
  const response = await instance.delete(
    GROUP_MANAGEMENT_URLS.DELETE_GROUP_ADMIN_LAVEL.replace(
      ':id',
      id?.toString()
    )
  );
  return response;
};
